import type { MapClient, MapCoords, MapFeatureData } from "../../types";
import type { Map as MaptilerMap } from "@maptiler/sdk";

export class MaptilerClient implements MapClient<MaptilerMap> {
  constructor(private map: MaptilerMap) {}

  getBounds() {
    const bounds = this.map.getBounds();
    if (!bounds) {
      return null;
    }

    return {
      sw: { lat: bounds.getSouth(), lng: bounds.getWest() },
      ne: { lat: bounds.getNorth(), lng: bounds.getEast() },
    };
  }

  setBounds(bounds: { sw: MapCoords; ne: MapCoords }, options?: { animate?: boolean }) {
    this.map.fitBounds([bounds.sw, bounds.ne], { animate: options?.animate });
  }

  goToCoords(coords: MapCoords, zoomLevel?: number) {
    this.map.jumpTo({
      center: [coords.lng, coords.lat],
      zoom: zoomLevel ?? this.map.getZoom(),
    });
  }

  getZoomLevel(): number {
    return this.map.getZoom();
  }

  setZoomLevel(zoomLevel: number): void {
    this.map.setZoom(zoomLevel);
  }

  getCoords(): MapCoords {
    const center = this.map.getCenter();
    return {
      lat: center.lat,
      lng: center.lng,
    };
  }

  queryRenderedFeatures(): MapFeatureData[] {
    return this.map.queryRenderedFeatures().map((feature) => ({
      name: feature.properties?.name,
      class: feature.properties?.class,
    }));
  }

  getRawClient(): MaptilerMap {
    return this.map;
  }
}
